import { useRouteError } from "react-router";
import Page_not_found from "../../assets/img/Error/Page_not_found.png";

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <div id="error-page">
      <div>
        <h1>Oops!</h1>
        <img src={Page_not_found} alt="Page_not_found" />
        <p>Sorry, an unexpected error has occurred.</p>
        <p>
          <i>{error.statusText || error.message}</i>
        </p>
      </div>
    </div>
  );
}
